export const faqs = [
  {
    question: "What’s the first step in purchasing and renting a property?",
    answer:
      "You get started by booking a schedule with us to look over your property preference, desired location and budget.",
  },
  {
    question: "Is it necessary to work with a real estate agent?",
    answer:
      "Whether it’s buying, selling or leasing, we highly recommend working with a trusted real estate advisory service provider to offer you strategic insights, professional guidance, and skilled negotiation to you as a client.  We ensure you make informed and confident decisions.",
  },
  {
    question: "Can I purchase or rent a property if my budget isn't complete yet?",
    answer:
      "Yes you can. Within our network, we have properties with flexible payments plan that can met your needs.",
  },
];
